
import React, { useState, useEffect } from 'react';

const COLORS = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500'];

const Simon: React.FC = () => {
  const [sequence, setSequence] = useState<number[]>([]);
  const [userSequence, setUserSequence] = useState<number[]>([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeColor, setActiveColor] = useState<number | null>(null);
  const [score, setScore] = useState(0);

  const start = () => {
    const first = Math.floor(Math.random() * 4);
    setSequence([first]);
    setUserSequence([]);
    setScore(0);
    playSequence([first]);
  };

  const playSequence = async (seq: number[]) => {
    setIsPlaying(true);
    for (const colorIdx of seq) {
      await new Promise(r => setTimeout(r, 500));
      setActiveColor(colorIdx);
      await new Promise(r => setTimeout(r, 400));
      setActiveColor(null);
    }
    setIsPlaying(false);
  };

  const handlePress = (idx: number) => {
    if (isPlaying) return;
    const nextUser = [...userSequence, idx];
    setUserSequence(nextUser);
    
    if (idx !== sequence[nextUser.length - 1]) {
      alert("System Overload! Score: " + score);
      setSequence([]);
      return;
    }

    if (nextUser.length === sequence.length) {
      setScore(s => s + 1);
      const nextSeq = [...sequence, Math.floor(Math.random() * 4)];
      setSequence(nextSeq);
      setUserSequence([]);
      setTimeout(() => playSequence(nextSeq), 800);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-8 text-2xl font-black text-slate-100">MEMORY LOAD: {score}</div>
      <div className="grid grid-cols-2 gap-4">
        {COLORS.map((color, i) => (
          <button
            key={i}
            onClick={() => handlePress(i)}
            className={`w-32 h-32 rounded-2xl transition-all transform active:scale-95 ${color} ${activeColor === i ? 'brightness-150 scale-105 shadow-[0_0_30px_white]' : 'brightness-50'}`}
          />
        ))}
      </div>
      <button onClick={start} className="mt-12 bg-slate-700 px-8 py-2 rounded-full font-bold">RE-SYNC SYSTEM</button>
    </div>
  );
};

export default Simon;
